export const statusEmun = {
  ONLINE: 'Active',
  OFFLINE: 'Disabled',
};
